import {
  NpcByBrandAction,
  NpcByBrandActionTypes,
  NpcByBrandState,
} from '../../types/npcByBrand';

const initialState: NpcByBrandState = {
  brands: [],
  byBrand: {
    profitCenters: [],
    markets: [],
    locationIds: [],
    locations: [],
    byMonth: [],
    total: {},
  },
  byBrandConst: {
    markets: [],
    locations: [],
    getData: false,
  },
  loading: false,
  brandsLoading: true,
};

export const npcByBrandReducer = (
  state = initialState,
  action: NpcByBrandAction
): NpcByBrandState => {
  switch (action.type) {
    case NpcByBrandActionTypes.GET_ALL_NS_BRANDS:
      return {
        ...state,
        brands: action.payload,
        brandsLoading: false,
      };
    case NpcByBrandActionTypes.GET_NPC_BY_BRAND:
      return {
        ...state,
        byBrand: { ...state.byBrand, ...action.payload },
        byBrandConst: {
          ...state.byBrandConst,
          markets: state.byBrandConst.getData
            ? state.byBrandConst.markets
            : action.payload.markets,
          locations: state.byBrandConst.getData
            ? state.byBrandConst.locations
            : action.payload.locations,
          getData: true,
        },
        loading: false,
      };
    case NpcByBrandActionTypes.SET_NPC_BY_BRAND_LOADING:
      return {
        ...state,
        loading: true,
      };
    case NpcByBrandActionTypes.CLEAR_NPC_BY_BRAND:
      return initialState;
    default:
      return state;
  }
};
